/**
 * AOI Location — pin + radius scorecard (sidebar page).
 */
import { MapPinned } from 'lucide-react';
import LocationScorecardTab from '../../components/location/LocationScorecardTab';

export default function AoiLocation() {
    return (
        <div className="space-y-3">
            <div className="flex flex-wrap items-end justify-between gap-3">
                <div>
                    <h1 className="text-2xl font-extrabold flex items-center gap-2 text-ink-900">
                        <MapPinned className="h-5 w-5 text-brand-teal-700" /> AOI Location
                    </h1>
                    <p className="text-sm text-ink-500 mt-1">
                        Pin → fetch catchment → fill property terms → download or save.
                    </p>
                </div>
            </div>
            <LocationScorecardTab />
        </div>
    );
}
